import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "email-list-input"
  }, [_vm.label ? _c('label', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.novoEmail,
      expression: "novoEmail",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.invalidState
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.novoEmail
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.adicionar.apply(null, arguments);
      },
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.novoEmail = $event.target.value.trim();
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "btn btn-light-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.adicionar
    }
  }, [_c('i', {
    staticClass: "fa fa-plus mr-1"
  }), _vm._v(" Adicionar ")])])]), _vm.erroLocal ? _c('small', {
    staticClass: "text-danger d-block mt-1"
  }, [_vm._v(" " + _vm._s(_vm.erroLocal) + " ")]) : _vm.error ? _c('small', {
    staticClass: "text-danger d-block mt-1"
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")]) : _vm._e(), _c('div', {
    staticClass: "email-list-input__chips mt-2"
  }, _vm._l(_vm.emails, function (email) {
    return _c('span', {
      key: email,
      staticClass: "badge badge-light border mr-2 mb-2"
    }, [_vm._v(" " + _vm._s(email) + " "), _c('button', {
      staticClass: "btn btn-xs btn-icon ml-1",
      attrs: {
        "type": "button",
        "disabled": _vm.disabled,
        "aria-label": "Remover ".concat(email)
      },
      on: {
        "click": function click($event) {
          return _vm.remover(email);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])]);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };